.Main {
    padding: var(--small-space) 0 0 0;
}

.Title {
    line-height: 1.7;
    padding: 0 0 1.7em 0;
}

.Item {
    border-bottom: solid 2px currentColor;
    padding: 1.7em 0;
}

.Button {
    display: grid;
    grid-template: minmax(0, max-content) / minmax(0, 1fr) minmax(0, max-content);
    line-height: 1.7;
    background: none;
    border: none;
    width: 100%;
    box-sizing: border-box;
    grid-gap: var(--space);
    text-align: left;
    padding: 0;
    align-items: center;
}

.Button a {
    border-bottom: solid 2px currentColor;
}

.Button svg {
    width: 20px;
    height: 12px;
    fill: none;
    stroke-width: 2px;
    stroke: var(--fg);
}

.IsOpen .Button svg {
    transform: rotate(180deg);
}

.Text {
    display: none;
    line-height: 1.7;
    padding: 0 var(--space) 0 0;
}

.IsOpen .Text {
    display: block;
}